export const DEFAULT_MARKUP: number = 12;
export const MIN_MARKUP: number = 0;
